<template>
  <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-12 col-lg-12">
          <h1 class="text-white pt-3 px-3">ตั้งค่าการเรียกรถเข้ารับ</h1>
          <p
              class="text-white pb-0 px-3"
          >เปลี่ยน / ตั้งค่าการเรียกรถเข้ารับ</p>
        </div>
      </div>
    </base-header>
    <div class="text-center" v-if="busy">
      <BlockUI>
        <div class="loader"></div>
      </BlockUI>
    </div>
    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12 col-md-12 col-lg-12">
                  <b-form-group
                      class="mb-0"
                      label-align="right"
                      label-cols='3'
                      v-for="item in courierList"
                      :key="item.key"
                  >
                    <template v-slot:label>
                      <b-img style="height: 32px;width: auto" :src="'/img/courier_icons/'+item.icon" fluid alt="Responsive image"></b-img>
                    </template>
                    <b-form-radio-group
                        class="pt-2"
                        v-model="item.callStyle"
                    >
                      <b-form-radio name="some-radios" value="0">自动呼叫</b-form-radio>
                      <b-form-radio name="some-radios" value="1">手动呼叫</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <div class="col-12 col-md-12 col-lg-12" style="display: flex;align-items: center;justify-content: center">
                    <button class="btn btn-info btn-sm-res mt-5" @click="Confirm">
                      <span>Confirm</span>
                    </button>
                  </div>

                  <hr class="d-md-none d-lg-none" />
                </div>
                <div class="col-12 col-md-6 col-lg-12 mb-3">
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API;
export default {
  data() {
    return {
      busy:false,
      courierList:[],
    }
  },
  created(){
    this.getCourierList()
  },
  methods: {
    // 获取快递公司列表
    async getCourierList(){
      let courierPostcodeDetails = JSON.parse(localStorage.getItem('courier_postcode'))
      let cpd = 0
      if (courierPostcodeDetails) {
        cpd = courierPostcodeDetails.version
      } else {
        cpd = 0
      }
      this.busy = true
      await this.$http
          .get(API_URL + `/shop/${cpd}`, {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          })
          .then(res => {
            this.busy = false
            let addCallConfigCustom = res.data.data.couriers.filter(item => item.key === 'FLE' || item.key === 'EMST')
            for (let i = 0; i < addCallConfigCustom.length; i++) {
              const element = addCallConfigCustom[i]
              element.callStyle = 0
            }
            this.courierList = addCallConfigCustom
            console.log(this.courierList)
          })
    },
    Confirm(){

    },
  },
}
</script>

<style lang="scss" scoped>
.warning-text {
  background: #FAF1CB;
}
.status-complete {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  width: 100px;
  height: 30px;
  background: rgba(217, 243, 201, 0.65);
  border-radius: 3px;
  color: #4EC217;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.2px;
}
.status-wait {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  width: 100px;
  height: 30px;
  background: rgba(243, 241, 201, 0.65);
  border-radius: 3px;
  color: #E8AB0E;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.2px;
}
.status-cancel {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  width: 100px;
  height: 30px;
  background: rgba(243, 211, 201, 0.65);
  border-radius: 3px;
  color: #E8290E;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.2px;
}
.status-recieve {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  width: 100px;
  height: 30px;
  background: rgba(243, 241, 201, 0.65);
  border-radius: 3px;
  color: #E8AB0E;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.2px;
}
</style>
